import { Injectable } from '@angular/core';
import {
  CanDeactivate,
  // ActivatedRouteSnapshot,
  // RouterStateSnapshot,
  UrlTree,
} from '@angular/router';
import { Observable } from 'rxjs';
import { DirtyComponent } from '../components/errors/dirty-check.component';

@Injectable({
  providedIn: 'root',
})
export class DirtyCheckGuard implements CanDeactivate<DirtyComponent> {
  canDeactivate(
    component: DirtyComponent
    // _next: ActivatedRouteSnapshot,
    // _state: RouterStateSnapshot
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    if (component.canDeactivate()) {
      return confirm(
        'There are changes you have made to the page. If you quit, you will lose your changes.'
      );
    } else {
      return true;
    }
  }
}
